<section class='logo-preview d-flex justify-content-start flex-row flex-nowrap'>
  <img [src]='logoSrc' alt='logo' class='brand-logo-preview' />

</section>
